import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useGetModulesListQuery } from '../../../api/queries/getModulesList';
import { ModuleType } from '../../../api/types';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NoItemResult from '../../../components/results/NoItemResult';
import NotFoundResult from '../../../components/results/NotFoundResult';
import CtsDetailsInnerPage from './CtsDetailsInnerPage';

const CtsDetailsPage = () => {
    const { t } = useTranslation(['ctsDetails']);
    const company = useCompany(true);

    const { data, loading } = useGetModulesListQuery({
        variables: { filter: { companyId: company?.id, moduleType: ModuleType.CtsModule } },
    });

    if (!company) {
        return <NoItemResult subTitle={t('ctsDetails:noCompanySelected')} />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    if (isEmpty(data?.modules?.items)) {
        return <NotFoundResult />;
    }

    return <CtsDetailsInnerPage modules={data.modules.items} />;
};

export default CtsDetailsPage;
